import { render, staticRenderFns } from "./TmpBlock.vue?vue&type=template&id=2ecf1c16&scoped=true&"
import script from "./TmpBlock.vue?vue&type=script&lang=ts&"
export * from "./TmpBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TmpBlock.vue?vue&type=style&index=0&id=2ecf1c16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecf1c16",
  null
  
)

export default component.exports